import withProvider from './src/redux/withProvider';
import './src/styles/fonts.scss';
import './src/styles/global.scss';
// import LogRocket from 'logrocket';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';

// Initialize Application Insights
let appInsights = null;
if (typeof window !== 'undefined' && process.env.GATSBY_APPINSIGHTS_CONNECTION_STRING) {
  appInsights = new ApplicationInsights({
    config: {
      connectionString: process.env.GATSBY_APPINSIGHTS_CONNECTION_STRING,
      enableAutoRouteTracking: true,
      enableAjaxPerfTracking: true,
      enableRequestHeaderTracking: true,
      enableResponseHeaderTracking: true,
      enableCorsCorrelation: true,
      correlationHeaderExcludedDomains: ['*.google.com', '*.googleapis.com', '*.google-analytics.com'],
    }
  });
  appInsights.loadAppInsights();
}

export const wrapRootElement = withProvider;

const transitionDelay = 300;

export const shouldUpdateScroll = ({
  routerProps: { location },
  getSavedScrollPosition,
}) => {
  if (location.action === 'PUSH') {
    window.setTimeout(() => window.scrollTo(0, 0), transitionDelay)
  } else {
    const savedPosition = getSavedScrollPosition(location)
    window.setTimeout(
      () => window.scrollTo(...(savedPosition || [0, 0])),
      transitionDelay
    )
  }
  return false
}

// To do. Add logrocket in production
// export const onClientEntry = () => {
//   LogRocket.init(process.env.GATSBY_LOGROCKET_API_KEY);
// };